import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import ToolCard from './ToolCard';
import { ToolsSectionProps } from '../types/types';

const ToolsSection: React.FC<ToolsSectionProps> = ({
  viperTool,
  rhoTool,
  convTool,
  handleToolChange,
  formatCurrency
}) => {
  return (
    <Card className="mb-4 section">
      <Card.Header as="h2">TOOLS</Card.Header>
      <Card.Body>
        <Row className="tools-grid">
          <Col md={4}>
            <ToolCard
              title="HOC Viper"
              toolType="viper"
              toolData={viperTool}
              cardClass="hoc-viper-card"
              handleToolChange={handleToolChange}
              formatCurrency={formatCurrency}
            />
          </Col>

          <Col md={4}>
            <ToolCard
              title="HOC RHO"
              toolType="rho"
              toolData={rhoTool}
              cardClass="hoc-rho-card"
              handleToolChange={handleToolChange}
              formatCurrency={formatCurrency}
            />
          </Col>

          <Col md={4}>
            <ToolCard
              title="Conventional Tool"
              toolType="conv"
              toolData={convTool}
              cardClass="conventional-card"
              handleToolChange={handleToolChange}
              formatCurrency={formatCurrency}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ToolsSection;
